function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M14.891 12.55v-2.248a.248.248 0 0 0-.248-.248H9.186v-2.49a3.225 3.225 0 1 0-.496 0v2.49H3.233a.248.248 0 0 0-.249.248v2.248a2.233 2.233 0 1 0 .497 0v-2H8.69v2a2.233 2.233 0 1 0 .496 0v-2h5.21v2a2.233 2.233 0 1 0 .495 0zM6.21 4.349a2.729 2.729 0 1 1 5.458 0 2.729 2.729 0 0 1-5.458 0zM4.97 14.767a1.736 1.736 0 1 1-3.473 0 1.736 1.736 0 0 1 3.473 0zm5.705 0a1.736 1.736 0 1 1-3.472 0 1.736 1.736 0 0 1 3.472 0zm3.97 1.737a1.736 1.736 0 1 1 0-3.473 1.736 1.736 0 0 1 0 3.473z"
});

var SvgWorkflow = function SvgWorkflow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWorkflow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/workflow.9f11766a.svg";
export { ForwardRef as ReactComponent };